import { MessageGetter } from 'react-message-context';
import { ExpenseReportForm, ExpenseReportFormType } from '../../types/expense-reports';

export const getExpenseReportDisplayTitle = (expenseReport: ExpenseReportForm, t: MessageGetter): string => {
  switch (expenseReport.formType) {
    case ExpenseReportFormType.GeneralExpenseReport:
      return t('generalExpenseReport.title');
    case ExpenseReportFormType.TravelExpenseReport:
      return t('travelExpenseReport.title');
    default:
      return '';
  }
};
